import React from 'react'
import { Subtask } from 'constants/interfaces'
import { FileText } from 'lucide-react'
import FileIcon from 'components/CommonComponents/JSXIcons/FileIcon'
import {
  CameraIcon,
  VideoIcon,
  PollIcon,
  PrivatePollIcon,
  QuestionIcon,
  LinkIcon,
  AiCameraIcon,
} from 'components/CommonComponents/JSXIcons'
export function SubtaskIcon({ subtask, size = 40 }: { subtask: Subtask; size?: number }) {
  const Icon = subtask.is_ai_enhanced
    ? AiCameraIcon
    : (
        {
          2: CameraIcon,
          4: VideoIcon,
          5: FileIcon,
          6: PollIcon,
          10: PrivatePollIcon,
          8: QuestionIcon,
          3: LinkIcon,
        } as Record<number, typeof CameraIcon>
      )[subtask.type]
  const glyphSize = size === 40 ? 20 : 30
  return Icon ? (
    <Icon width={`${size}px`} height={`${size}px`} iconWidth={glyphSize} iconHeight={glyphSize} />
  ) : (
    <FileText size={glyphSize} />
  )
}
